import { DownloadOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import React from 'react';

import DrawerButton from 'components/Views/Creative/Drawers/DrawerButton';
import type Bundle from 'stores/Bundle';

export interface DownloadBundleButtonProps {
  bundle: Bundle;
}

function DownloadBundleButton({ bundle }: DownloadBundleButtonProps) {
  // FIXME: consider just using an A tag
  return (
    <DrawerButton
      disabled={bundle.loading}
      onClick={() => {
        window.open(bundle.downloadURL, '_blank');
      }}
    >
      <DownloadOutlined />
    </DrawerButton>
  );
}

export default observer(DownloadBundleButton);
